import * as Yup from 'yup'
import { contact } from './messages'

export default Yup.object().shape({
    name: Yup.string().required(contact.name.required),

    email: Yup.string()
        .required(contact.email.required)
        .email(contact.email.invalid),

    phone: Yup.string().required(contact.phone.required),

    company: Yup.string().required(contact.company.required),

    message: Yup.string().required(contact.message.required),
})
